export default __webpack_public_path__ + "static/media/endOfService.e3b15ed9.webp";